import React, { FC } from 'react';
import Modal from './common/Modal/Modal';

interface ModalRefundApprovalProps {
  isShow: boolean;
  onRequestClose: () => void;
  onAgree: () => void;
}

const ModalWithdrawApproval: FC<ModalRefundApprovalProps> = ({
  isShow,
  onRequestClose,
  onAgree,
}) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      isXButton={false}
      onClose={onRequestClose}
      title="Transaction confirmation"
      explanation={
        <>
          Once confirmed, transaction history
          <br />
          may be checked through txhash.
        </>
      }
      footerComponent={
        <button
          onClick={() => {
            onAgree();
            onRequestClose();
          }}
          className="btn btn-block btn-primary btn-lg"
        >
          Confirm
        </button>
      }
    />
  );
};

export default ModalWithdrawApproval;
